import { createFileRoute } from "@tanstack/react-router";

import { PageHeading } from "@/components/site/PageHeading";
import { PageHero } from "@/components/site/PageHero";
import { Button } from "@/components/ui/button";
import contactHeader from "@/assets/contact-header.webp.asset.json";
import { useLocale } from "@/lib/i18n/context";

export const Route = createFileRoute("/contact")({
  staticData: { sitemap: true },
  head: () => ({
    meta: [
      { title: "Contact & Secretariat — Foreign Council On Economic Relations" },
      {
        name: "description",
        content: "Get in touch with the Secretariat of the Foreign Council On Economic Relations.",
      },
      { property: "og:title", content: "Contact & Secretariat — Foreign Council On Economic Relations" },
      {
        property: "og:description",
        content: "Get in touch with the Secretariat of the Foreign Council On Economic Relations.",
      },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://foreign-council.org/contact" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: "https://foreign-council.org/contact" }],
  }),
  component: ContactPage,
});

function ContactPage() {
  const { t } = useLocale();

  return (
    <>
      <PageHero image={contactHeader.url} alt="Berlin" />
      <section className="bg-surface">
      <div className="mx-auto w-full max-w-[1400px] px-5 py-16 lg:px-8 lg:py-20">
        <PageHeading title={t.contact.title} />

        <div className="grid gap-12 lg:grid-cols-[1.2fr_0.8fr]">
          <div className="space-y-6">
            <div>
              <h2 className="fc-h4 font-bold text-foreground">{t.contact.email}</h2>
              <Button asChild variant="link" className="mt-3 h-auto whitespace-normal break-all p-0 fc-body">
                <a href="mailto:reg@foreign-council.org">reg@foreign-council.org</a>
              </Button>
            </div>
            <div>
              <h2 className="fc-h4 font-bold text-foreground">{t.contact.phone}</h2>
              <Button asChild variant="link" className="mt-3 h-auto p-0 fc-body">
                <a href="tel:+4930692067500">+49 30 692067500</a>
              </Button>
            </div>
          </div>

          <div className="border border-dashed border-foreground bg-card p-6 lg:p-8">
            <h2 className="fc-h4 font-bold text-foreground">Contact</h2>
            <p className="mt-4 whitespace-pre-line fc-body text-muted-foreground">
              {"Foreign Council On Economic Relations\nBauhofstraße 1\n10117 Berlin\nDeutschland\nT: +49 30 692067500"}
            </p>
          </div>
        </div>
      </div>
    </section>
    </>
  );
}
